import { surfaceClassName } from '../../utils/dashboardStyles';
import DashboardEmptyState from './DashboardEmptyState';

function SummaryCard({ label, value, detail }) {
  return (
    <article className={`${surfaceClassName} p-5 sm:p-6`}>
      <p className="m-0 text-[0.82rem] sm:text-sm text-[var(--theme-text-muted)]">{label}</p>
      {value ? (
        <>
          <strong className="my-3 block text-[2.2rem] font-semibold leading-none tracking-[-0.04em] text-[var(--theme-text)] sm:text-[2.65rem] xl:text-[3rem]">
            {value}
          </strong>
          <span className="text-[0.92rem] text-[var(--theme-text-muted)] sm:text-[0.98rem]">{detail}</span>
        </>
      ) : (
        <div className="mt-3">
          <DashboardEmptyState compact message="Waiting for live dashboard data." />
        </div>
      )}
    </article>
  );
}

export default SummaryCard;
